// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2uelN","selected":"Chip_selected__1Jo7j"};